import { deleteRequest, post, put } from 'helpers/api';

export const ADD_PLAN = 'ADD_PLAN';
export function addPlan(plan) {
  return { type: ADD_PLAN, plan };
}

export const CHANGE_PLAN = 'CHANGE_PLAN';
export function changePlan(plan, changes) {
  return { type: CHANGE_PLAN, plan, changes };
}

export const SET_PLAN = 'SET_PLAN';
export function setPlan(plan) {
  return { type: SET_PLAN, plan };
}

export const REMOVE_PLAN = 'REMOVE_PLAN';
export function removePlan(plan) {
  return { type: REMOVE_PLAN, plan };
}

export function createPlan(plan) {
  return async (dispatch, getState) => {
    const createdPlan = await savePlan(plan, getState());
    dispatch(addPlan(createdPlan));
  };
}

export function updatePlan(plan, changes) {
  return async (dispatch, getState) => {
    const updatedPlan = await savePlan({ ...plan, ...changes }, getState());
    dispatch(setPlan(updatedPlan));
  };
}

export function archivePlan(plan, newPlanId) {
  return async (dispatch) => {
    const response = await post(`${plan.path}/archive`, { newPlanId });
    dispatch(setPlan(response.commissionPlan));
  };
}

export function deletePlan(plan) {
  return async (dispatch) => {
    if (plan.payablesCount === 0) {
      await deleteRequest(plan.path);
      dispatch(removePlan(plan));
    }
  };
}

async function savePlan(plan, state) {
  const { tiers, users, ...commissionPlan } = plan;
  commissionPlan.tiersAttributes = tiers.map((tier, i) => ({ ...tier, order: i }));
  commissionPlan.usersAttributes = users.map(user => ({ id: user.id }));

  const callApi = plan.path ? put : post;
  const response = await callApi(plan.path || state.paths.base, { commissionPlan });
  return response.commissionPlan;
}
